// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1H7xJ","vLegacy":"SelectSecondary_vLegacy__leWKf","error":"SelectSecondary_error__2L9qi","disabled":"SelectSecondary_disabled__UcQeg"};